import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsSegmentedControlComponent } from "./ds-segmented-control.component";
import { DsSegmentedOptionModule } from "../ds-segmented-option/ds-segmented-option.module";

@NgModule({
  declarations: [DsSegmentedControlComponent],
  imports: [CommonModule, DsSegmentedOptionModule],
  exports: [DsSegmentedControlComponent, DsSegmentedOptionModule],
})
export class DsSegmentedControlModule {}
